import { useResetPassword } from '@goparrot-dashboard-api/auth';
import { useI18n } from '@goparrot-dashboard/i18n';
import { useNotifications, PageTitle, PositiveFeedback } from '@goparrot-dashboard/shared-ui';
import * as React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { SignInLink } from '../components/SignInLink';
import { SignInSubtitle } from '../components/SignInSubtitle';
import { EMAIL_AUTOCOMPLETE_KEY } from '../constants';
import { SetupPasswordForm } from '../forms/SetupPasswordForm';

/**
 * @description Page used to change email after requesting Forgot Password
 */
export const ResetPasswordPage: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { getIntlString } = useI18n();
  const { notifyError } = useNotifications();

  const { params } = useRouteMatch<{ token: string }>();

  const resetPassword = useResetPassword({
    onError: () => {
      notifyError({
        text: getIntlString('error.resetPassword'),
      });
    },
    onSuccess: (response) => {
      sessionStorage.setItem(EMAIL_AUTOCOMPLETE_KEY, response.email);
    },
  });

  return (
    <>
      <header>
        <PageTitle hasMargin={false} fontWeight="medium" seoTitle={getIntlString('title.resetPassword')}>
          {getIntlString('title.resetPassword')}
        </PageTitle>
        <SignInSubtitle />
      </header>
      <section className="tw-mt-4 tw-relative">
        {!resetPassword.data ? (
          <SetupPasswordForm
            onSubmit={({ password }) =>
              resetPassword.mutate({
                password,
                resetPasswordToken: params?.token,
              })
            }
            isFormLoading={resetPassword.isLoading}
          />
        ) : (
          <PositiveFeedback
            title={getIntlString('feedback.resetSuccess.title')}
            subtitle={
              <p className="tw-mb-0">
                {getIntlString('feedback.nextLogin.subtitle.first')} <SignInLink /> {getIntlString('feedback.nextLogin.subtitle.second')}
              </p>
            }
          />
        )}
      </section>
    </>
  );
};
